import React from 'react';
import AuthorizationLayout from '../../Layout/AuthorizationLayout';
import recoveryImage from '../../../../assets/images/recovery.svg';
import AuthorizationLayoutTablet from '../../Layout/Tablet/AuthorizationLayoutTablet';
import { Routes, Route } from 'react-router-dom';
import PasswordRecoverySentLink from './Steps/SentLink/PasswordRecoverySentLink';
import PasswordRecoveryConfirm from './Steps/Confirm/PasswordRecoveryConfirm';
import PasswordRecoveryFinished from './Steps/Finished/PasswordRecoveryFinished';

function PasswordRecoveryPage() {
  return (
    <AuthorizationLayout background={recoveryImage} backgroundStyle={{ backgroundSize: '34rem', backgroundPosition: 'center' }}>
      <AuthorizationLayoutTablet>
        <Routes>
          <Route path={'/'} element={<PasswordRecoverySentLink />} />
          <Route path={'/confirm/:token'} element={<PasswordRecoveryConfirm />} />
          <Route path={'/success'} element={<PasswordRecoveryFinished />} />
        </Routes>
      </AuthorizationLayoutTablet>
    </AuthorizationLayout>
  );
}

export default PasswordRecoveryPage;
